var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "# icons / credit-card 2 gradient 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EDF9A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23B1E3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#-icons-/-credit-card-2-gradient-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.890625,16 L14.109375,16 C12.9462891,16 12,16.9462891 12,18.109375 L12,29.4058838 C12,30.5689698 12.9462891,31.5152588 14.109375,31.5152588 L33.890625,31.5152588 C35.0537109,31.5152588 36,30.5689698 36,29.4058838 L36,18.109375 C36,16.9462891 35.0537109,16 33.890625,16 Z M33.890625,30.1090088 L14.109375,30.1090088 C13.7217407,30.1090088 13.40625,29.7935181 13.40625,29.4058838 L13.40625,23.4831543 L34.59375,23.4831543 L34.59375,29.4058838 C34.59375,29.7937012 34.2782593,30.1090088 33.890625,30.1090088 Z M14.109375,17.40625 L33.890625,17.40625 C34.2782593,17.40625 34.59375,17.7217407 34.59375,18.109375 L34.59375,18.8895874 L13.40625,18.8895874 L13.40625,18.109375 C13.40625,17.7217407 13.7217407,17.40625 14.109375,17.40625 Z M13.40625,20.2958374 L34.59375,20.2958374 L34.59375,22.0770874 L13.40625,22.0770874 L13.40625,20.2958374 Z M17.4550781,27.362793 C17.8434448,27.362793 18.1582031,27.6777344 18.1582031,28.065918 C18.1582031,28.4542847 17.8434448,28.769043 17.4550781,28.769043 L15.7243652,28.769043 C15.3359985,28.769043 15.0212402,28.4542847 15.0212402,28.065918 C15.0212402,27.6777344 15.3359985,27.362793 15.7243652,27.362793 L17.4550781,27.362793 Z M21.6117554,27.362793 C22.0001221,27.362793 22.3148804,27.6777344 22.3148804,28.065918 C22.3148804,28.4542847 22.0001221,28.769043 21.6117554,28.769043 L19.8810425,28.769043 C19.4928589,28.769043 19.1779175,28.4542847 19.1779175,28.065918 C19.1779175,27.6777344 19.4928589,27.362793 19.8810425,27.362793 L21.6117554,27.362793 Z M32.4807129,25.2217407 L29.390625,25.2217407 C29.0022583,25.2217407 28.6875,25.5366821 28.6875,25.9248657 L28.6875,28.0344238 C28.6875,28.4227905 29.0022583,28.7375488 29.390625,28.7375488 L32.4807129,28.7375488 C32.8688965,28.7375488 33.1838379,28.4227905 33.1838379,28.0344238 L33.1838379,25.9248657 C33.1838379,25.536499 32.8688965,25.2217407 32.4807129,25.2217407 Z M31.7775879,27.3312988 L30.09375,27.3312988 L30.09375,26.6279907 L31.7775879,26.6279907 L31.7775879,27.3312988 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.51a0d266938469d4d7dd3171cb0926dc.svg";
export { ForwardRef as ReactComponent };